<script>
    import css from "./prompt-content.css";

    export let hideFn = Function;
    export let className = "";

    function handleClick(e) {
        if (e.currentTarget === e.target) {
            hideFn();
        }
    }
</script>

<div class="{css.overlay}" on:click={handleClick}>
    <div class="{`${css.prompt} ${className}`}">
        <div class="{css.inner}">
            <slot></slot>
        </div>
    </div>
</div>
